import { NgModule } from "@angular/core";

import { VarDirective } from "./ng-var.directive";
import { ValueOrActionDirective } from './value-or-action.directive';
import { RestrictPermissionsDirective } from './restrict-permissions.directive';
import { CustomPermissionsDirective } from './custom-permissions.directive';
import { InitDirective } from "./init.directive";

@NgModule({
    imports: [
        RestrictPermissionsDirective,
    ],
    declarations: [
        CustomPermissionsDirective,
        VarDirective,
        ValueOrActionDirective,
        InitDirective,
    ],
    exports: [
        RestrictPermissionsDirective,
        CustomPermissionsDirective,
        VarDirective,
        ValueOrActionDirective,
        InitDirective,
    ]
})

export class DirectivesModule { }